import range from 'lodash/range'

const startYear = 1970
const endYearExclusive = new Date().getFullYear() - 1

export const GRAD_YEARS = range(endYearExclusive, startYear)
